var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.91675 22.375H26.9792C29.7938 22.375 32.0834 24.6646 32.0834 27.4792C32.0834 30.2937 29.7938 32.5833 26.9792 32.5833C24.1647 32.5833 21.8751 30.2937 21.8751 27.4792V26.75",
    stroke: "#1B9CF9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.91675 18.0001H26.9792C29.7792 18.0001 32.0834 15.7105 32.0834 12.8959C32.0834 10.0959 29.7792 7.79175 26.9792 7.79175C24.1792 7.79175 21.8751 10.0813 21.8751 12.8959V13.6251",
    stroke: "#1B9CF9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.91675 13.6249H13.5772C15.7501 13.6249 17.5001 11.8603 17.5001 9.70197C17.5001 7.52905 15.7355 5.77905 13.5772 5.77905C11.4042 5.77905 9.65424 7.54364 9.65424 9.70197V10.2561",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWind);
export default __webpack_public_path__ + "static/media/wind.e87a781593ec5dbe7d67f3fcfd1a90f6.svg";
export { ForwardRef as ReactComponent };